import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';
import { updateJobDescription } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const UpdateJobDescriptionForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, closeUpdateJobDescriptionModal, updateUpdateJobDescriptionTitle } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    updateJobDescription({
      onResponse,
      onError,
      body: {
        authenticityToken,
        updateJobDescription: biopharmaGroupState?.updateJobDescription,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Job Title">
        <Input
          type="text"
          value={biopharmaGroupState?.updateJobDescription?.title || ''}
          onChange={(e) => updateUpdateJobDescriptionTitle(e.target.value)}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeUpdateJobDescriptionModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Update
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default UpdateJobDescriptionForm;
